import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-2 overflow-y-auto-md overflow-y-auto-sm" }
const _hoisted_2 = { class: "container table-width" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row text-white py-2 table-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-10 d-flex align-items-center fs-14 lh-20" }, [
    /*#__PURE__*/_createElementVNode("span", null, "項目")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 text-center d-flex align-items-center justify-content-center fs-14 lh-14" }, [
    /*#__PURE__*/_createElementVNode("span", null, "已登錄面積")
  ])
], -1)
const _hoisted_4 = { class: "col-10 ps-4 py-3 text-elite-blue lh-20 fs-14 d-flex" }
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = { class: "col-2 py-3 text-center text-elite-blue lh-20 fs-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['row', { 'bg-gray': index % 2 != 0 }]),
          key: item.name
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.numberChange(index + 1)), 1),
            _createTextVNode(" " + _toDisplayString(item.name), 1)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(item.registered_area), 1)
        ], 2))
      }), 128))
    ])
  ]))
}